export default "__VITE_ASSET__DYovPghw__"